import { render, staticRenderFns } from "./AddChildModal.vue?vue&type=template&id=890ef6f8&scoped=true"
import script from "./AddChildModal.vue?vue&type=script&lang=js"
export * from "./AddChildModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890ef6f8",
  null
  
)

export default component.exports